module.exports = function() {
  return new Worker(__webpack_public_path__ + "e8074a6503a3eb33a91f.worker.js");
};